(function () {

    var formApp = angular.module('formApp');
    // this controller is used to invoke all the error messages, alerts and confirmation messages.
    formApp.controller("modalPopupController", ['$scope', '$uibModalInstance', '$filter', 'DataServices', 'UtilityServices', 'popupCode', 'popupParams', 'Constants', function ($scope, $uibModalInstance, $filter, DataServices, UtilityServices, popupCode, popupParams, Constants) {

        $scope.utility = UtilityServices;
        $scope.configData = DataServices.configData;
        $scope.popup = {};
        $scope.params = {};
        $scope.errorMessages = [];
        $scope.response = {};

        if (window.location.href.indexOf('DH') > -1) {
            $scope.IsDHVisible = true;
            //return true;
        }
        else {
            $scope.IsDHVisible = false;
        }
        if (window.location.href.indexOf('DFFH') > -1) {
            $scope.IsDFFHVisible = true;
            //return true;
        }
        else {
            $scope.IsDFFHVisible = false;
        }

        $scope.popup = Constants.Popup[popupCode];
        if (popupCode == 'privacyNotice') {
            if (sessionStorage.getItem('popupNoticeState') != 'shown') {
                // Issuing a Privacy notice for Complaints users
                $scope.popup = {
                    code: 'privacyNotice',
                    title: 'Privacy Notice',
                    text: 'You are about to access FMS Complaints and the records it contains.  You must only search for and access records that you need to do your job.  You must not access any record that is not needed for your job, and in particular you must not access records that are not relevant to your department.  Unauthorised access to records may be a breach of privacy laws, your legal obligations as a staff member and the VPS Code of Conduct, and may result in disciplinary action and legal liability.  To gain access to FMS Complaints you must click ‘AGREE’, acknowledging you have read and understood this notice; if you do not do this you will not be given access.',
                    type: 'confirm',
                    okButtonText: 'Agree',
                    cancelButtonText: 'Disagree',
                    thirdButtonText: ''
                };
                sessionStorage.setItem('popupNoticeState', 'shown')
            }
        }
        

        if (popupCode == 'invalidUser') {
            
                // Issuing an Unauthorised user notice to the users
                $scope.popup = {
                    code: 'unauthorisedUser',
                    title: 'Unauthorised User',
                    text: 'You are not authorised to access this application. Please check your Url or contact your administrator.'
                };
        }

        // Get popup config from configData
        // (NOTE: popup might be falsy if DataServices.configData has not been loaded yet - for example, when the call to getConfigData fails and we try to display the error popup)
        if ($scope.popup === null || $scope.popup === undefined) {
            popup = $filter('filter')($scope.configData && $scope.configData.popups, { code: popupCode }, true);
            $scope.popup = popup && popup[0];
        }
        
        if (!$scope.popup && $scope.configData) {
            // Issuing a generic error message if DataServices.configData is not available or does not contain the requested popup
            $scope.popup = {
                severity: 'error',
                title: 'Unknown Error',
                text: 'An unknown error has occurred. Please reload the FMS application.',
                type: 'info',
                okButtonText: 'Close'
            };
        }

        if ($scope.popup.questions) {
            $scope.questions = $scope.popup.questions;
        }

        if (popupParams) {
            $scope.params = popupParams;
        }

        //this function is called to accept the message.
        $scope.ok = function () {
            if ($scope.validatePopUp().length == 0) {
                if ($scope.popup.code == 'privacyNotice') {
                    sessionStorage.setItem('popupNoticeAgreed', 'shown')
                }
                //$uibModalInstance.close('ok');
                var result = { result: 'ok', outParams: $scope.response };
                $uibModalInstance.close(result);
            }
        };

        // this function is called on click of Third Button
        $scope.popupThirdButton = function () {
            if ($scope.validatePopUp().length == 0) {
                //$uibModalInstance.close('ok');
                var result = { result: 'thirdButtonClick', outParams: $scope.response };
                $uibModalInstance.close(result);
            }
        };


        // this function is called to cancel the operation
        $scope.cancel = function () {
            if ($scope.popup.code == 'privacyNotice') {
                $location.path('/logout');
            }
            else {
                $uibModalInstance.dismiss('cancel');
            }
        };

        // validate popup questions
        $scope.validatePopUp = function () {
            $scope.errorMessages = [];
            angular.forEach($scope.questions, function (value) {
                $scope.validateQuestion(value.code);
            });
            return $scope.errorMessages;
        }

        // validate single question
        $scope.validateQuestion = function (code) {
            $scope.removeError(code);
            if (!$scope.response[code]) {
                var errorQuestion = _.find($scope.questions, function (q) { return q.code == code; });
                var errorValidation = _.find(errorQuestion.validations, function (v) { return v.level == "inline"; });
                if (errorValidation) {
                    $scope.errorMessages.push({ "code": code, "controlType": errorQuestion.controlType, "inlineMessage": errorValidation.inlineMessage });
                    $scope.utility.setQuestionErrorState(code, true);
                }
            } else {
                $scope.utility.setQuestionErrorState(code, false);
            }
        }

        // clears error from question
        $scope.removeError = function (code) {
            _.remove($scope.errorMessages, function (e) { return e.code === code; });
        }

        // resets response for each question
        var clearResponses = function () {
            angular.forEach($scope.questions, function (value) {
                $scope.response[value.code] = null;
            });
        }

        // Filter for typeahead to ensure it only searches from the beginning of the word and will consider spaces.
        $scope.typeAheadStartsWithFilter = function (option, viewValue) {
            // if option.matchingText is specified, use option.matchingText instead of option.text
            return option.matchingText ?
                (option.matchingText.substr(0, viewValue.length).toLowerCase() == viewValue.toLowerCase()) :
                (option.text && option.text.substr(0, viewValue.length).toLowerCase() == viewValue.toLowerCase());
        }

        clearResponses();
    }]);
}());